import { DataService } from './dataService'
export const airfreightratesServices = {
	addAirfreightrates: async (data) => {
		return DataService.post('/admin/add_airfreightrats', data)
	},

	updateAirfreightrates: async (data) => {
		return DataService.post('/admin/update_airfreightrats', data)
	},

	updateAirfreightratestatus: async (data) => {
		return DataService.post('/admin/update_airfreightrats_status', data)
	},

	getAirfreightrates: async (data) => {
		return DataService.get('/admin/get_airfreightrats', data)
	},

	importAirfreightratsData: async (data) => {
		return DataService.post('/admin/import_airfreightrats_data', data)
	},

	exportAirfreightratsData: async (data) => {
		return DataService.get('/admin/export_airfreightrats_data', data)
	},

}

export default airfreightratesServices;